import { render } from "./OnlineAppealCorruptionPage.vue?vue&type=template&id=5b9f0162"
import script from "./OnlineAppealCorruptionPage.vue?vue&type=script&lang=js"
export * from "./OnlineAppealCorruptionPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__